export interface IContactMechanismType {
  contactMechanismTypeId: number;
  name: string;
}

export class ContactMechanismType implements IContactMechanismType {
  contactMechanismTypeId: number;
  name: string;
}
